import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment, { Moment } from 'moment';
import React, { memo } from 'react';
import trackingService, { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import InputContainer from './InputContainer';

interface IDateTimePickerInputProps {
    title?: string;
    value?: Date | null;
    denoteRequired?: boolean;
    handleChange: (date: Date | null) => void;
    track: TrackingEvent;
}

const DateTimePickerInput: React.FC<IDateTimePickerInputProps> = (props) => {
    const handleDateChange = (newValue: Moment | null) => {
        const dateTime = newValue ? new Date(newValue.toString()) : null;
        props.handleChange(dateTime);
        trackingService.track({
            ...props.track,
            eventValue: dateTime,
        });
    };

    return (
        <InputContainer title={props.denoteRequired && props.title ? `${props.title} *` : props.title}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                    label=""
                    value={props.value ? moment(props.value) : null}
                    onChange={handleDateChange}
                    ampm={false}
                    views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
                    slotProps={{
                        textField: {
                            variant: 'outlined',
                            placeholder: '',
                            label: '',
                            sx: {
                                '& input': {
                                    padding: '9px 14px',
                                },
                            },
                        },
                    }}
                />
            </LocalizationProvider>
        </InputContainer>
    );
};

export default memo(DateTimePickerInput);
